'use client';
export let SizeEnum = /*#__PURE__*/function (SizeEnum) {
  SizeEnum["XS"] = "xs";
  SizeEnum["SM"] = "sm";
  SizeEnum["MD"] = "md";
  SizeEnum["LG"] = "lg";
  SizeEnum["XL"] = "xl";
  return SizeEnum;
}({});
export let TypographySizeEnum = /*#__PURE__*/function (TypographySizeEnum) {
  TypographySizeEnum["XS"] = "xs";
  TypographySizeEnum["SM"] = "sm";
  TypographySizeEnum["MD"] = "md";
  TypographySizeEnum["LG"] = "lg";
  TypographySizeEnum["XL"] = "xl";
  TypographySizeEnum["XL2"] = "2xl";
  TypographySizeEnum["XL3"] = "3xl";
  TypographySizeEnum["XL4"] = "4xl";
  TypographySizeEnum["XL5"] = "5xl";
  TypographySizeEnum["XL6"] = "6xl";
  return TypographySizeEnum;
}({});

/** Basic size type (xs, sm, md, lg) */